import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { TowLogTableComponent } from './components/tow-log-table/tow-log-table.component';
import { TowLogEventCodePipe } from './pipes/tow-log-event-code.pipe';

@NgModule({
  imports: [CommonModule, SharedModule, TowLogEventCodePipe],
  declarations: [TowLogTableComponent],
  exports: [TowLogTableComponent],
})
export class TowLogModule {}
